import { render } from "./DneExchange.vue?vue&type=template&id=0eedfc37&scoped=true"
import script from "./DneExchange.vue?vue&type=script&lang=js"
export * from "./DneExchange.vue?vue&type=script&lang=js"

import "./DneExchange.vue?vue&type=style&index=0&id=0eedfc37&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eedfc37"]])

export default __exports__